<template>
  <div>
    <a-form-model :model="queryParam"
                  class="exi_form v2"
                  ref="form"
                  :label-col="{ flex: '0 0 auto' }"
                  :wrapper-col="{ span: 24 }">
      <a-form-model-item label="品目编码" style="width: 300px">
        <a-input placeholder="请输入需要查询的品目编码" @keyup.enter="onSearch" v-model="queryParam.fspmbm"></a-input>
      </a-form-model-item>
      <a-form-model-item label="品目名称" style="width: 300px">
        <a-input placeholder="请输入需要查询的品目名称" @keyup.enter="onSearch" v-model="queryParam.fspmmc"></a-input>
      </a-form-model-item>
      <a-button type="primary" icon="search" @click="onSearch">查询</a-button>
      <a-button type="Default" @click="onReSet">清空</a-button>
    </a-form-model>
    <s-table
        class="mt-4"
        ref="table"
        :rowSelection="{selectedRowKeys: userSelectContent.map(item => item.fid), onChange: onSelectChangeTable,
                columnTitle:' ',type: rowSelectionType, // 隐藏默认全选/反选菜单
                getCheckboxProps: record =>({ props: { disabled: disableArr.includes(record.fspmbm) || (record.fspmbm.indexOf(disableArr[3]) !== -1 && record.nextLevelNumber>0) } })}"
        :columns="columns"
        :pagination="taskPagination"
        :pageSize="pageSize"
        :data="loadData"
        :rowKey="record => record.fid"
    >
      <template slot="itemLinkName" slot-scope="text, record">
        <span v-html="onReplaceLinkName(record.itemLinkName,record.fspmmc)"></span>
      </template>
    </s-table>
  </div>
</template>

<script>
import STable from '@/components/Table'
import {
  QueryPurchaseItems
} from '@/epp/expertmain/purchaseitems/PurchaseRequest'
import DictCascader from '@/components/dict/DictCascader.vue'

const disableArr = ['A', 'B', 'C', '000000']
export default {
  name: 'SearchPurchaseItem',
  components: {
    DictCascader,
    STable
  },
  mounted () {
  },
  props: {
    pageSize: {
      type: Number,
      default: 5
    },
    pageSizeOptions: {
      type: Array,
      default () {
        return [' 5', '8']
      }
    },
    userSelectContent: {
      type: Array,
      default () {
        return []
      }
    },
    rowSelectionType: {
      type: String,
      default: 'checkbox'
    },
    limitNum: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      // 用于记录历史选中
      disableArr,
      taskPagination: {
        showTotal: total => `共 ${total} 条`,
        size: 'small',
        pageSizeOptions: this.pageSizeOptions
      },
      columns: [
        {
          title: '品目名称',
          scopedSlots: { customRender: 'itemLinkName' }
        },
        {
          title: '品目编码',
          with: '10px',
          dataIndex: 'fspmbm'
        },
      ],
      copyData: [],
      queryParam: {
        fspmmc: undefined,
        fspmbm: undefined,
      },
      loadData: async parameter => {
        if (!this.queryParam || !this.queryParam.fspmmc && !this.queryParam.fspmbm){
        return {
          page:{...parameter,total:0},
          result: []
        }
        }
        const params = { ...parameter, ...this.queryParam }
        return QueryPurchaseItems(params)
      },
    }
  },
  created () {
  },
  methods: {
    //选择品目
    onSelectChangeTable (selectedRowKeys, selectedRows) {
      let userSelectContent = []
      if (this.limitNum && selectedRowKeys.length > this.limitNum) {
        this.$message.error(`最多允许选择${this.limitNum}个品目，您已选择${this.userSelectContent.length}个。`)
        return
      }
      this.copyData = this.copyData.concat(selectedRows)
      selectedRowKeys.forEach(item => {
        const data = this.copyData.filter(it => it.fid === item)[0]
        data.checked = true
        userSelectContent.push(data)
      })
      console.log(selectedRowKeys)
      console.log(userSelectContent)
      this.$emit('syncUserSelectContent', userSelectContent)
    },
    onSearch () {
      this.$refs.table?.refresh(true)
    },
    onReSet () {
      this.queryParam = {}
      this.onSearch()
    },
    onReplaceLinkName (linkName, currentName) {
      //替换最后与currentName一样的为蓝色标签,修复字符串中有特殊符号无法识别的问题
      return linkName && linkName.replace(new RegExp(currentName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$'), '<a>' + currentName + '</a>')
    },
    //同步copyData
    async syncCopyData (data) {
      if (data) {
        this.copyData = this.copyData.concat(data)
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
